import React, {Component} from 'react'
// import {Input} from "antd";
import TagItem from "./TagItem";
import { isEmail, sendNotification } from '../../../utils'
// KEY_CODE_DELETE, KEY_CODE_ENTER,
import { injectIntl } from 'react-intl';
import {isValidEmail} from "../UploadFolderUtils";
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Select, Spin } from "antd";
const { Option } = Select;

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0",
};
export class UsersEmails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            emailValue: '',
            hasFocus: false,
            emails: [],
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPressArrow, { once: false })
    }

    handleKeyPressArrow = e => {
        if(!this.state.hasFocus) return;
        // switch (e.keyCode) {
        //     case KEY_CODE_DELETE:
        //     this.handleRemove()
        //     break
        //     case KEY_CODE_ENTER:
        //     this.handleAddition()
        //     break
        //     default:
        //     break
        // }
    }

    handleAddition = () => {
        const {intl} = this.props;
        const {emailValue} = this.state;
        if(emailValue.length > 0 && isValidEmail(emailValue)){
            this.props.onAdd(emailValue);
            this.setState({
                emailValue: ""
            });
        }else{
            sendNotification('error', intl, intl.formatMessage({ id: 'upload-folder-s3-email-incorrect' }))
        }
    }
    handleRemove = () => {
        const {emailValue} = this.state;
        if(emailValue.length > 0) return;
        this.props.onRemove();
    }
    onFocus = () => {
        this.setState({
            hasFocus: true
        });
    }

    onBlur = () => {
        this.setState({
            hasFocus: false
        });
    }

    handleChangeEmail = (values) => {
      // const onlyValidEmails = values
      const onlyValidEmails = values.filter(email => isEmail(email));
      // this.setState({ usersEmails: onlyValidEmails })
      this.props.onAdd(onlyValidEmails);

    }
    
    render(){

        // const {
        //     emailValue
        // } = this.state;

        const {
            usersEmails,
            onRemove,
            inputEnabled,
            usersEmailAutoComplete,
            showSpinnerEmail
        } = this.props;
        const usersEmailAuto = usersEmailAutoComplete ? usersEmailAutoComplete : []
        const optionsUser = usersEmailAuto.map((user) => {
          return (
            <Option key={user._id} value={user.email} uid={user._id}>
              {`${user.name} (${user.email})`}
            </Option>
          );
        });    
        const optionsSpinner = 
          <Option key={'spinner_loading'} >
            <div style={spinnerStyle}>
              <Spin spinning={true} />
            </div>
          </Option> 
        return (
            <React.Fragment>
                {/* {inputEnabled && <Input 
                    value={emailValue} 
                    onChange={(e)=>{
                        this.setState({
                            emailValue: e.target.value
                        })
                    }}
                    allowClear={true} 
                    style = {{marginBottom: "10px"}}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />} */}
                {inputEnabled && <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  onChange={this.handleChangeEmail}
                  tokenSeparators={[","]}
                  value={ usersEmails }
                >
                  {showSpinnerEmail && optionsSpinner}
                  {optionsUser}
                </Select>}
                {!inputEnabled && <div className='tag_row' style = {{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap"
                }}>
                    {
                        usersEmails.map(e => (
                            <TagItem
                                key = {e}
                                label = {e}
                                width = {180}
                                onRemove = {()=>{
                                    onRemove(e)
                                }}
                            />
                        ))
                    }
                </div>}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        uploadFolder: state.uploadFolder,
    }
  }
  
const mapDispatchToProps = {
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersEmails)))
